import React from 'react';
import './trade.css';
import mobileTrading from "../../../assets/mobile_trading_apps.png"; // 👈 New mobile trading image

const TradeAndManage = () => {
  return (
    <section className="trade-manage-section">
      <div className="content-wrapper">
        <div className="image-gallery">
          <img src={mobileTrading} alt="StoneForex mobile trading applications" className="mobile-apps-image" />
        </div>
        
        <div className="text-content">
          <h2 className="section-title">Trade And Manage With <span>StoneForex</span></h2>
          <p className="section-subtitle">
            Experience seamless trading from anywhere in the world with our advanced mobile platform. 
            StoneForex delivers professional-grade tools and instant execution at your fingertips.
          </p>

          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">
                <div className="learn-icon"></div>
              </div>
              <div className="feature-content">
                <h3>Learn</h3>
                <p>
                  Master the markets with our comprehensive demo accounts and educational resources. 
                  Build confidence with risk-free practice trading.
                </p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <div className="trade-icon"></div>
              </div>
              <div className="feature-content">
                <h3>Trade</h3>
                <p>
                  Execute trades with lightning speed using our professional MT4 platform. 
                  Manage your portfolio seamlessly across all devices.
                </p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <div className="withdraw-icon"></div>
              </div>
              <div className="feature-content">
                <h3>Withdraw</h3>
                <p>
                  Access your profits instantly with our global withdrawal network. 
                  Fast, secure, and available worldwide 24/7.
                </p>
              </div>
            </div>
          </div>

          <button className="start-trading-button">Get Started Today</button>
        </div>
      </div>
    </section>
  );
};

export default TradeAndManage;
